import { render, staticRenderFns } from "./AddClassType.vue?vue&type=template&id=49a898ac&scoped=true&"
import script from "./AddClassType.vue?vue&type=script&lang=ts&"
export * from "./AddClassType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a898ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a898ac')) {
      api.createRecord('49a898ac', component.options)
    } else {
      api.reload('49a898ac', component.options)
    }
    module.hot.accept("./AddClassType.vue?vue&type=template&id=49a898ac&scoped=true&", function () {
      api.rerender('49a898ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/classes/AddClassType.vue"
export default component.exports